export default "__VITE_ASSET__D$LzDm77__"